(function () {
  const storageKey = 'collectionProductView';
  const listClass = 'product-grid--list-view';
  const gridClass = 'product-grid--grid-view';
  const rootListClass = 'collection-product-view-list';

  function getSavedView() {
    const params = new URLSearchParams(window.location.search);
    const viewParam = params.get('view');

    if (viewParam === 'list' || viewParam === 'grid') {
      saveView(viewParam);
      return viewParam;
    }

    try {
      return window.localStorage.getItem(storageKey) === 'list' ? 'list' : 'grid';
    } catch (error) {
      return 'grid';
    }
  }

  function saveView(view) {
    try {
      window.localStorage.setItem(storageKey, view);
    } catch (error) {
      // localStorage can be unavailable in private browsing; the view still changes for this page.
    }
  }

  function applyView(view) {
    const productGrid = document.getElementById('product-grid');
    const controls = document.querySelectorAll('[data-product-view]');
    const effectiveView = view === 'list' ? 'list' : 'grid';

    document.documentElement.classList.toggle(rootListClass, effectiveView === 'list');

    if (productGrid) {
      productGrid.classList.toggle(listClass, effectiveView === 'list');
      productGrid.classList.toggle(gridClass, effectiveView !== 'list');
    }

    controls.forEach((control) => {
      const isActive = control.dataset.productView === effectiveView;
      control.classList.toggle('is-active', isActive);
      control.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function setView(view) {
    saveView(view);
    applyView(view);
  }

  function updatePaginationUrl(link) {
    const view = getSavedView();
    const url = new URL(link.href);

    if (view === 'list') {
      url.searchParams.set('view', 'list');
    } else {
      url.searchParams.delete('view');
    }

    link.href = url.toString();
  }

  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-product-view]');
    const paginationLink = event.target.closest('.pagination a[href]');

    if (paginationLink) {
      updatePaginationUrl(paginationLink);
      return;
    }

    if (!control) return;
    setView(control.dataset.productView === 'list' ? 'list' : 'grid');
  });

  applyView(getSavedView());

  document.addEventListener('DOMContentLoaded', () => {
    applyView(getSavedView());
    window.addEventListener('resize', () => applyView(getSavedView()));

    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    const observer = new MutationObserver(() => applyView(getSavedView()));
    observer.observe(gridContainer, { childList: true, subtree: true });
  });
})();
